import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppProvider from './providers/AppProvider';

// Silence console output in production to avoid leaking details
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  try { console.log = noop; } catch (_) {}
  try { console.warn = noop; } catch (_) {}
  try { console.error = noop; } catch (_) {}
  try { console.debug = noop; } catch (_) {}
  try { console.info = noop; } catch (_) {}
}

// Disable service worker and clear any existing caches to avoid stale bundle issues
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations()
      .then((regs) => {
        regs.forEach((reg) => reg.unregister());
      })
      .catch(() => {});
    try {
      if (typeof caches !== 'undefined' && caches.keys) {
        caches.keys().then((keys) => keys.forEach((k) => caches.delete(k))).catch(() => {});
      }
    } catch (_) {}
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
